"use strict";

import angular from "angular";

import template from "./alert-notification-contaazul.component.html";
import "./alert-notification-contaazul.component.scss";

class AlertNotificationComponent {
    constructor() {
        this.isBodyOpen = false;
    }

    openBody() {
        if (this.showMoreInfo) this.isBodyOpen = true;
    }

    closeBody() {
        if (this.showMoreInfo) this.isBodyOpen = false;
    }

    toggleBody() {
        if (this.showMoreInfo) this.isBodyOpen = !this.isBodyOpen;
    }
}

AlertNotificationComponent.$inject = [];

export { AlertNotificationComponent };

const name = "alertNotificationComponent";
const def = {
    bindings: {
        type: "@",
        icon: "@",
        titleText: "@",
        description: "@",
        showMoreInfo: "<",
        buttonCustom: "@"
    },
    transclude: true,
    controller: AlertNotificationComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
